export default __webpack_public_path__ + "images/QK.7bd50cd.png";